import { render, staticRenderFns } from "./Displays.vue?vue&type=template&id=1921a8bc&scoped=true"
import script from "./Displays.vue?vue&type=script&lang=js"
export * from "./Displays.vue?vue&type=script&lang=js"
import style0 from "./Displays.vue?vue&type=style&index=0&id=1921a8bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1921a8bc",
  null
  
)

export default component.exports